import axios from 'axios';

// const CryptoJS = require('crypto-js');
/* eslint-disable */
const member_api = 'emc-api-server.eilis-ai.com';



const state = {
    aesCode: '',
    lineToken: '',
    lineName: '',
    pictureUrl: '',
    errorDia3: false,
    errorLog: ''
}

const getters = {
    aesCode: state => state.aesCode,
    lineToken: state => state.lineToken,
    pictureUrl: state => state.pictureUrl,
    lineName: state => state.lineName,
    errorDia3: state => state.errorDia3,
    errorLog: state => state.errorLog
}

const mutations = {
    CHANGE_AES_CODE(state, payload) {
        state.aesCode = payload;
    },
    GET_USER_DATA(state, payload) {
        state.lineToken = payload.userId;
        state.pictureUrl = payload.pictureUrl;
        state.lineName = payload.displayName;
    },
    OPEN_DIA(state, payload) {
        state.errorDia3 = payload;
    },
    SEND_ERROR_LOG(state, payload) {
        state.errorLog = payload;
    }
}

// 測試更新
const actions = {
    getEncryptData({ }, payload) {
        const apiUrl = `https://${member_api}/getEncryptData`;
        return axios.post(apiUrl, payload).then((res) => {
            return res;
        })
    },
    saveToNotReceiveList({ }, payload) {
        const apiUrl = `https://${member_api}/saveToNotReceiveList`;
        return axios.post(apiUrl, payload).then((res) => {
            return res;
        })
    },
    getNotReceivedUser({ }, payload) {
        const apiUrl = `https://${member_api}/getNotReceivedUser`;
        return axios.post(apiUrl, payload).then((res) => {
            return res;
        })
    },
    getBasicId({ }, payload) {
        const apiUrl = `https://api-linebiz.eilis-ai.com/app/GetBasicID`;
        return axios.post(apiUrl, payload).then((res) => {
            return res;
        })
    },
    getLiffProfile({ state, commit }, payload) {
        try {
            liff.init(payload).then(() => {
                liff.getProfile().then((_profile) => {
                    commit('GET_USER_DATA', _profile);
                    localStorage.setItem('pictureUrl', _profile.pictureUrl);
                })
                .catch((e) => {
                    commit('OPEN_DIA', true);
                    commit('SEND_ERROR_LOG', 'GET USER ERROR');
                })
            })
            .catch((e) => {
                commit('OPEN_DIA', true);
                commit('SEND_ERROR_LOG', 'LIFF INIT ERROR');
            })
        }
        catch(e) {
            commit('SEND_ERROR_LOG', 'ERROR 088');
            commit('OPEN_DIA', true);
        }
    },
    getAESCode({ state, commit }, payload) {
        localStorage.setItem('aesCode', payload.aesCode);
        commit('CHANGE_AES_CODE', payload.aesCode);
    },
    checkPhone({ }, payload) {
        const apiUrl = `https://${member_api}/checkPhone`;
        return axios.post(apiUrl, payload).then((res) => {
            return res;
        })
    },
    checkBindAcc({ }, payload) {
        const apiUrl = `https://${member_api}/checkBindingAcc`;
        return axios.post(apiUrl, payload).then((res) => {
            return res.data;
        });
    },
    getAESData({ }, contents) {
        const apiUrl = `https://${member_api}/api/${contents.auth}/v1/getAESData`;
        const postData = {
            content: contents.content
        };
        return axios.post(apiUrl, postData)
            .then((res) => {
                return res;
            })
    },
    sendSMS({ }, contents) {
        const apiUrl = 'https://louisa-api-server.eilis-ai.com/sendSMS'
        const data = {
            phone: contents.phone, // 起始交易日期
            message: (contents.countryCode === '886') ? `你的驗證碼為: ${contents.code} (Powered by EILIS)` : `Your verification code: ${contents.code} (Powered by EILIS)`,
            service: contents.service,
            auth: contents.auth,
            countryCode: contents.countryCode
        };
        return axios.post(apiUrl, data)
            .then((res) => {
                return res;
            })
    },
    checkBindUser({ }, payload) {
        const apiUrl = `https://${member_api}/checkisBindingUser`;
        return axios.post(apiUrl, payload).then((res) => {
            return res.data;
        })
    },
    fastLogin({ }, payload) {
        const apiUrl = `https://${member_api}/fastClearance`;
        return axios.post(apiUrl, payload).then((res) => {
            return res.data;
        });
    },
    checkRecomPhone({ }, payload) {
        const apiUrl = `https://${member_api}/checkRecomPhone`;
        return axios.post(apiUrl, payload)
            .then((res) => {
                return res;
            });
    },
    sendMemberAPI({ }, payload) {
        const apiUrl = `https://${member_api}/api/sendMember`;
        return axios.post(apiUrl, payload)
            .then((res) => {
                return res;
            })
    },
    createUser({ }, payload) {
        const apiUrl = `https://${member_api}/register`;
        return axios.post(apiUrl, payload)
            .then((res) => {
                return res.data;
            });
    },
    sendLoginRecom({ }, payload) {
        const apiUrl = `https://${member_api}/loginRecom`;
        return axios.post(apiUrl, payload)
            .then((res) => {
                return res;
            });
    },
    exchangeGiftCode({ }, payload) {
        const apiUrl = `https://${member_api}/exchangeGiftCode`;
        return axios.post(apiUrl, payload)
            .then((res) => {
                return res;
            })
    }
}

export default {
    namespaced: true,
    state, getters, mutations, actions
}